import {
  extendObservable
} from 'mobx';
import getWeather from '../requests/getWeather';
import {
  addHoursChangeEvent,
  addMinutesChangeEvent,
  removeHoursChangeEvent,
  removeMinutesChangeEvent,
} from '../utils/datetime';


export default class WeatherStore {
  constructor() {
    extendObservable(this, {
      weather: undefined,
      currentTemp: undefined,
      currently: undefined,
      days: undefined,
      upcomingHours: undefined,
      isLoading: true
    });

    this.getClosestHourData = this.getClosestHourData.bind(this);
    this._loadData = this._loadData.bind(this);
    this._updateInternal = this._updateInternal.bind(this);

    this._loadData();
    this._loadEvents = [];

    addHoursChangeEvent('weather_update_from_api', this._loadData);
    addMinutesChangeEvent('weather_update_internal', this._updateInternal);
  }

  _loadData() {
    getWeather(weather => {
      this.weather = weather;
      this._updateInternal();

      if (this._loadEvents.length) {
        this._loadEvents.forEach(event => event(this));
        this._loadEvents = [];
      }
      this.isLoading = false;
    });
  }

  _updateInternal() {
    const hourData = this.getClosestHourData()
    const now = new Date();

    this.currently = hourData;
    this.currentTemp = hourData.temperature;
    this.days = this.weather.daily.data;
    this.upcomingHours = this.weather.hourly.data.filter(hour => {
      return new Date(hour.time * 1000).valueOf() > now.valueOf();
    })
  }

  destroy() {
    removeHoursChangeEvent('weather_update_from_api');
    removeMinutesChangeEvent('weather_update_internal');
  }

  get(alarmID, fn) {
    if (this.isLoading) {
      this._loadEvents.push(store => {
        return fn(store.alarms.find(alarm => alarm.id === alarmID));
      });
    } else {
      return fn(this.alarms.find(alarm => alarm.id === alarmID));
    }
  }

  getClosestHourData() {
    const currentTime = new Date().valueOf() / 1000;
    let hours = [].concat(this.weather.currently, this.weather.hourly.data);
    hours = hours.sort((a, b) => (
      Math.abs(a.time - currentTime) - Math.abs(b.time - currentTime)
    ));
    return hours[0];
  }

  onLoad(fn) {
    if (this.isLoading) {
      this._loadEvents.push(store => {
        return fn(store);
      });
    } else {
      return fn(this);
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/WeatherStore.js